<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
*::-webkit-scrollbar {
  background-color: #fff;
  width: 15px;
}

*::-webkit-scrollbar-track {
  background-color: #fff;
}

*::-webkit-scrollbar-track:hover {
  background-color: #f4f4f4;
}

*::-webkit-scrollbar-thumb {
  background-color: #2DCE89;
  border-radius: 16px;
  border: 5px solid #fff;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a5;
  border: 4px solid #f4f4f4;
}

*::-webkit-scrollbar-button {
  display: none;
}
</style>
